import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

const PriceTagPaths = ({ color }) => (
  <g clipPath="url(#clip0_price_tag)">
    <path
      d="M14.5168 0.00679192C14.3698 0.0269566 14.2295 0.0847622 14.1118 0.174833L4.84079 7.27565C4.62696 7.43832 4.5 7.69238 4.5 7.96261L4.5 28.3923C4.50267 28.8682 4.88623 29.2513 5.35933 29.25H23.8973C24.3678 29.2487 24.7473 28.8655 24.75 28.3923V7.96261C24.7513 7.69374 24.627 7.43967 24.4159 7.27565L15.1448 0.174833C14.9657 0.0390558 14.74 -0.0214386 14.5168 0.00679192ZM14.6291 1.94129L23.0461 8.38719V27.5291H6.21093L6.21093 8.38719L14.6291 1.94129ZM14.5943 4.07339C13.8593 4.09221 13.2565 4.71062 13.2565 5.45401C13.2565 6.20952 13.8793 6.83598 14.6304 6.83598C15.3814 6.83598 15.9989 6.21086 15.9989 5.45401C15.9989 4.6985 15.3814 4.07339 14.6304 4.07339H14.5956H14.5943ZM11.455 13.3547C10.7761 13.3547 10.0971 13.6142 9.58394 14.1291C8.55888 15.1602 8.56556 16.8581 9.59062 17.8879C10.6157 18.919 12.2996 18.927 13.3274 17.8946C14.3551 16.8621 14.3538 15.1602 13.3274 14.1293C12.8142 13.6144 12.1352 13.3547 11.455 13.3547ZM18.0892 14.898C17.862 14.8953 17.6442 14.9841 17.4825 15.144L10.5999 22.0608C10.4382 22.2234 10.3473 22.4426 10.3473 22.6711C10.3473 22.9009 10.4382 23.1201 10.5999 23.2814C10.7602 23.444 10.9794 23.5355 11.2066 23.5355C11.4338 23.5355 11.6516 23.444 11.8133 23.2814L18.6895 16.3647C18.8498 16.2034 18.9407 15.9842 18.9407 15.7544C18.9407 15.5258 18.8499 15.3067 18.6895 15.144C18.5291 14.9868 18.3137 14.898 18.0892 14.898ZM11.455 15.0768C11.6942 15.0768 11.9348 15.1682 12.1152 15.3497C12.476 15.7127 12.4814 16.3163 12.1219 16.6779C11.7624 17.0396 11.157 17.0409 10.7961 16.6779C10.4353 16.315 10.4353 15.7127 10.7961 15.3497C10.9765 15.1683 11.2158 15.0768 11.4563 15.0768H11.455ZM17.7348 19.7335C17.0786 19.7496 16.4264 20.0064 15.9293 20.5065C14.9029 21.5376 14.9042 23.2368 15.9293 24.2667C16.9543 25.2978 18.6409 25.2991 19.6688 24.2667C20.6965 23.2342 20.6951 21.5377 19.6688 20.5065C19.1382 19.9728 18.4339 19.716 17.7349 19.7322L17.7348 19.7335ZM17.7949 21.4475C18.0342 21.4475 18.2747 21.539 18.4551 21.7204C18.816 22.0834 18.8213 22.6937 18.4618 23.0554C18.1023 23.417 17.4969 23.4116 17.1361 23.0486C16.7752 22.6857 16.7752 22.0834 17.1361 21.7204C17.3165 21.5389 17.5557 21.4475 17.7963 21.4475L17.7949 21.4475Z"
      fill={color}
    />
  </g>
);

export default function PriceTag({ size = 40, withCircle = true, color = "#F2F2F2" }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 30 30";
  const iconTransform = withCircle ? "translate(25 25.375)" : "";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <PriceTagPaths color={color} />
      </g>
      <defs>
        <clipPath id="clip0_price_tag">
          <rect width="30" height="29.25" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
